<div mat-dialog-title>
  <span *ngIf="data.event.id">
    Vacation bearbeiten
  </span>
    <span *ngIf="!data.event.id">
    Vacation erstellen
  </span>
</div>

<div mat-dialog-content>
    <div class="flex flex-wrap -mx-2" [formGroup]="eventForm">
        <div class="w-full px-2" *ngIf="event.influencer as influencer">
            <div>Influencername: <span class="font-bold">{{influencer.name}}</span></div>
        </div>
        <div class="w-full px-2">
            <label>Ziel</label>
            <input class="styled dark" type="text" formControlName="destination"/>
        </div>
        <div class="w-1/2 px-2">
            <label>Start datum</label>
            <input type="text" formControlName="fromDate" class="styled dark" placeholder="Wähle ein Datum" [ngxMatDatetimePicker]="fromDatePicker" (click)="fromDatePicker.open()">
            <ngx-mat-datetime-picker [defaultTime]="[23,59,59]" #fromDatePicker></ngx-mat-datetime-picker>
        </div>
        <div class="w-1/2 px-2">
            <label>End datum</label>
            <input type="text" formControlName="toDate" class="styled dark" placeholder="Wähle ein Datum" [ngxMatDatetimePicker]="toDatePicker" (click)="toDatePicker.open()">
            <ngx-mat-datetime-picker [defaultTime]="[23,59,59]" #toDatePicker></ngx-mat-datetime-picker>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <div class="w-full text-right">
        <div (click)="save()" matRipple class="inline-block py-2 px-4 cursor-pointer font-bold bg-blue-500 text-white rounded">
            Speichern
        </div>
    </div>
</div>

<div mat-dialog-close class="dialog-closer"></div>


